@import '../../vars.css';

.content {
    padding: var(--gap-20) var(--gap-20) var(--gap-0);

    &:last-child {
        padding-bottom: var(--gap-20);
    }
}
